import "../chunk-D57E6H3M.mjs";

// src/hooks/usePointerDrag.ts
import { useCallback, useEffect, useRef } from "react";
function usePointerDrag() {
  const detachRef = useRef(null);
  useEffect(() => () => detachRef.current?.(), []);
  return useCallback((event, { onMove, onEnd }) => {
    if (event.button !== 0 || detachRef.current) return false;
    event.preventDefault();
    const handle = event.currentTarget;
    const { pointerId, clientX: startX, clientY: startY } = event;
    const previousUserSelect = document.body.style.userSelect;
    document.body.style.userSelect = "none";
    try {
      handle.setPointerCapture(pointerId);
    } catch {
    }
    const end = (reason) => {
      detachRef.current?.();
      onEnd?.(reason);
    };
    const handleMove = (moveEvent) => {
      if (moveEvent.pointerId === pointerId) onMove(moveEvent.clientX - startX, moveEvent.clientY - startY);
    };
    const handleRelease = (endEvent) => {
      if (endEvent.pointerId === pointerId) end("release");
    };
    const handleCancel = (cancelEvent) => {
      if (cancelEvent.pointerId === pointerId) end("cancel");
    };
    const handleKeyDown = (keyEvent) => {
      if (keyEvent.key !== "Escape") return;
      keyEvent.preventDefault();
      keyEvent.stopPropagation();
      end("escape");
    };
    detachRef.current = () => {
      detachRef.current = null;
      document.body.style.userSelect = previousUserSelect;
      handle.removeEventListener("pointermove", handleMove);
      handle.removeEventListener("pointerup", handleRelease);
      handle.removeEventListener("pointercancel", handleCancel);
      handle.removeEventListener("lostpointercapture", handleRelease);
      window.removeEventListener("pointermove", handleMove);
      window.removeEventListener("pointerup", handleRelease);
      window.removeEventListener("keydown", handleKeyDown, true);
      if (handle.hasPointerCapture(pointerId)) handle.releasePointerCapture(pointerId);
    };
    handle.addEventListener("pointermove", handleMove);
    handle.addEventListener("pointerup", handleRelease);
    handle.addEventListener("pointercancel", handleCancel);
    handle.addEventListener("lostpointercapture", handleRelease);
    if (!handle.hasPointerCapture(pointerId)) {
      window.addEventListener("pointermove", handleMove);
      window.addEventListener("pointerup", handleRelease);
    }
    window.addEventListener("keydown", handleKeyDown, true);
    return true;
  }, []);
}
export {
  usePointerDrag
};
//# sourceMappingURL=usePointerDrag.mjs.map